module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='\n<form>\n\n\n    <div class="tab-contents js-tabs-container">\n\n        <!-- Basic Section -->\n        <div class="m-modal-section" >\n          <div class="m-modal-subsection" >\n\n            <div class="m-modal-column">\n              <div class="form-group">\n                  <input type="checkbox" name="enabled"  ';
 if (_.get(obj, 'enabled')) { 
__p+='checked="checked"';
 } 
__p+='/>\n                  <label for="" class="">Enabled</label>\n              </div>\n\n\n              <div class="form-group">\n                  <label for="name">Type</label>\n                  <select class="form-control js-selected-type" name="type">\n                      <option value="">Choose...</option>\n\n                      ';
 _.each(getReportTypes(), function(value, key){ 
__p+='\n                      ';
 if (obj._id) { 
__p+='\n                      <option value="'+
((__t=( key ))==null?'':__t)+
'" '+
((__t=( key === type ? 'selected' : void 0  ))==null?'':__t)+
'  >'+
((__t=( value ))==null?'':__t)+
'</option>\n                      ';
 } else { 
__p+='\n                      <option value="'+
((__t=( key ))==null?'':__t)+
'" >'+
((__t=( value ))==null?'':__t)+
'</option>\n                      ';
 } 
__p+='\n\n                      ';
 }); 
__p+='\n                  </select>\n              </div>\n              <div class="form-group">\n                  <label for="name">Recipients</label>\n                  <input type="input" class="form-control" name="recipients" placeholder="" value="'+
((__t=( recipientsCommaSep() ))==null?'':__t)+
'">\n              </div>\n              <div class="form-group">\n                  <label for="name">Interval</label>\n                  <select class="form-control js-selected-type" name="interval">\n\n                      ';
 _.each(getIntervals(), function(value, key){ 
__p+='\n                      ';
 if (obj._id) { 
__p+='\n                      <option value="'+
((__t=( key ))==null?'':__t)+
'" '+
((__t=( key === interval ? 'selected' : void 0  ))==null?'':__t)+
'  >'+
((__t=( value ))==null?'':__t)+
'</option>\n                      ';
 } else { 
__p+='\n                      <option value="'+
((__t=( key ))==null?'':__t)+
'" >'+
((__t=( value ))==null?'':__t)+
'</option>\n                      ';
 } 
__p+='\n\n                      ';
 }); 
__p+='\n                  </select>\n              </div>\n            </div>\n          </div>\n        </div>\n\n\n\n    </div>\n</form>\n';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./js/modules/client-mailreports/edit_new/templates/body.html
// module id = 419
// module chunks = 0